import { render, staticRenderFns } from "./bonusDayAdvanceFixed.vue?vue&type=template&id=2dc85512"
import script from "./bonusDayAdvanceFixed.vue?vue&type=script&lang=js"
export * from "./bonusDayAdvanceFixed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports